<template>
  <UFormGroup
    :label="$t('form.register.name')"
    name="name"
    required
  >
    <template #default="{ error }">
      <UInput
        :value="modelValue"
        :class="error ? 'border border-red rounded-md' : ''"
        :placeholder="$t('form.register.name')"
        :trailing-icon="error ? 'i-heroicons-exclamation-triangle' : ''"
        class="!mt-2"
        size="lg"
        type="text"
        @blur="emit('update:modelValue',  $event.target.value.replace(/\s\s+/g, ' '))"
      />
    </template>
  </UFormGroup>
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: {
    type: String,
    default: null,
    required: false,
  },
});

const emit = defineEmits(["update:modelValue"]);
</script>
